import { IAuthGuard } from "../utils/authGuard";
import { constants } from "./constants";

const { userRoles } = constants;

export interface IAppRoutesConfigValue {
  id?: string;
  path: string;
  relativePath?: string;
  authConfig?: IAuthGuard & {
    redirectUrl?: string
  }
}

export const appRoutes = {
  root: {
    path: "/"
  },
  login: {
    path: "/login",
  },
  home: {
    path: "/"
  },
  about: {
    id: "about",
    path: "/about",
    relativePath: "about",
  },
  members: {
    path: "/members",
    relativePath: "members",
    authConfig: {
      roles: [userRoles.ADMIN],
    },
  },
  memberDetail: {
    path: "/members/member-detail/:jid",
    relativePath: ":memberId",
    authConfig: {
      roles: [userRoles.ADMIN],
    },
  },
  gallery: {
    path: "/gallery",
    relativePath: "gallery",
  },
  usefullLinks: {
    path: "/useful-links",
    relativePath: "useful-links",
  },
  articles: {
    path: "/artcicles",
    relativePath: "articles",
  },
  resolutions: {
    path: "/resolutions",
    relativePath: "resolutions",
    authConfig: {
      roles: [userRoles.ADMIN],
    },
  }
} satisfies Record<string, IAppRoutesConfigValue>;
